module.exports = __webpack_public_path__ + "img/logos-certificados.9214a275.png";